var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftdesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 9220,
    viewBox: "0 0 94 9220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79b1a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30452",
    "data-name": "Group 30452",
    transform: "translate(-1770 -999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12454",
    "data-name": "Group 12454",
    transform: "translate(1769.73 1055.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12447",
    "data-name": "Group 12447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445",
    "data-name": "Group 12445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.205)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.205)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.205)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-2",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.141)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-2",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.141)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-2",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.141)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-3",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.335)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-3",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.335)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-3",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.335)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-4",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.399)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-4",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.399)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-4",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.399)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-2",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-5",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.077)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-5",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.077)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-5",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.077)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-2",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-6",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 -0.012)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-6",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 -0.012)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-6",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 -0.012)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-2",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-7",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.464)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-7",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.464)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-7",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.464)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-2",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-8",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.472)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-8",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.472)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-8",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.472)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-2",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-3",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-9",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.053)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-9",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.053)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-9",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.053)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-3",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-10",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.117)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-10",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.117)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-10",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.117)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-3",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-11",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.407)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-11",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.407)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-11",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.407)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-3",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-12",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.343)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-12",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.343)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-12",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.343)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-2",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-4",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-13",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.181)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-13",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.181)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-13",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.181)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-4",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-14",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.246)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-14",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.246)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-14",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.246)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-4",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-15",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.278)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-15",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.278)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-15",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.278)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-4",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-16",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.214)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-16",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.214)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-16",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.214)",
    fill: "url(#radial-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12446",
    "data-name": "Group 12446",
    transform: "translate(0 495.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-2",
    "data-name": "Group 12443",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-3",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-5",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-17",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.311)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-17",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.311)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-17",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.311)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-5",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-18",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.375)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-18",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.375)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-18",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.375)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-5",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-19",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.15)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-19",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.15)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-19",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.15)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-5",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-20",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.085)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-20",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.085)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-20",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.085)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-3",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-6",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-21",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.44)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-21",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.44)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-21",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.44)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-6",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-22",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.496)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-22",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.496)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-22",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.496)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-6",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-23",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.02)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-23",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.02)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-23",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.02)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-6",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-24",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.044)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-24",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.044)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-24",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.044)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-2",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-4",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-7",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-25",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.432)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-25",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.432)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-25",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.432)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-7",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-26",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.367)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-26",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.367)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-26",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.367)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-7",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-27",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.109)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-27",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.109)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-27",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.109)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-7",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-28",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.173)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-28",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.173)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-28",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.173)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-4",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-8",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-29",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.303)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-29",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.303)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-29",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.303)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-8",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-30",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.237)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-30",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.237)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-30",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.237)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-8",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-31",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.238)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-31",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.238)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-31",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.238)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-8",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-32",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.302)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-32",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.302)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-32",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.302)",
    fill: "url(#radial-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12448",
    "data-name": "Group 12448",
    transform: "translate(0 990.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445-2",
    "data-name": "Group 12445",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-3",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-5",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-9",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-33",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.173)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-33",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.173)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-33",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.173)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-9",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-34",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.109)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-34",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.109)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-34",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.109)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-9",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-35",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.367)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-35",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.367)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-35",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.367)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-9",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-36",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.431)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-36",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.431)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-36",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.431)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-5",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-10",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-37",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.044)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-37",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.044)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-37",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.044)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-10",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-38",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.021)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-38",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.021)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-38",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.021)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-10",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-39",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.495)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-39",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.495)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-39",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.495)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-10",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-40",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.44)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-40",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.44)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-40",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.44)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-3",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-6",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-11",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-41",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.085)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-41",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.085)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-41",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.085)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-11",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-42",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.15)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-42",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.15)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-42",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.15)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-11",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-43",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.375)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-43",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.375)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-43",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.375)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-11",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-44",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.311)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-44",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.311)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-44",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.311)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-6",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-12",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-45",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.213)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-45",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.213)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-45",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.213)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-12",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-46",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.278)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-46",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.278)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-46",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.278)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-12",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-47",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.246)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-47",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.246)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-47",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.246)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-12",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-48",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.182)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-48",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.182)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-48",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.182)",
    fill: "url(#radial-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12446-2",
    "data-name": "Group 12446",
    transform: "translate(0 495.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-4",
    "data-name": "Group 12443",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-7",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-13",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-49",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.343)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-49",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.343)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-49",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.343)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-13",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-50",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.407)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-50",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.407)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-50",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.407)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-13",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-51",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.117)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-51",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.117)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-51",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.117)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-13",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-52",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.052)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-52",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.052)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-52",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.052)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-7",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-14",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-53",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.472)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-53",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.472)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-53",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.472)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-14",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-54",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.464)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-54",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.464)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-54",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.464)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-14",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-55",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.012)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-55",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.012)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-55",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.012)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-14",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-56",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.077)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-56",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.077)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-56",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.077)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-4",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-8",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-15",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-57",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.399)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-57",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.399)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-57",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.399)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-15",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-58",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.335)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-58",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.335)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-58",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.335)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-15",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-59",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.141)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-59",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.141)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-59",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.141)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-15",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-60",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.206)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-60",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.206)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-60",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.206)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-8",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-16",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-61",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.27)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-61",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.27)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-61",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.27)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-16",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-62",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.205)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-62",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.205)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-62",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.205)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-16",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-63",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.27)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-63",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.27)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-63",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.27)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-16",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-64",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.334)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-64",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.334)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-64",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.334)",
    fill: "url(#radial-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12457",
    "data-name": "Group 12457",
    transform: "translate(1769.73 5018.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12447-2",
    "data-name": "Group 12447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445-3",
    "data-name": "Group 12445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-5",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-9",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-17",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-65",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.061)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-65",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.061)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-65",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.061)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-17",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-66",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.003)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-66",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.003)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-66",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.003)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-17",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-67",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.479)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-67",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.479)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-67",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.479)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-17",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-68",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.457)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-68",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.457)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-68",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.457)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-9",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-18",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-69",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.068)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-69",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.068)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-69",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.068)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-18",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-70",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.132)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-70",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.132)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-70",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.132)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-18",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-71",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.392)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-71",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.392)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-71",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.392)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-18",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-72",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.328)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-72",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.328)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-72",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.328)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-5",
    "data-name": "Group 12444",
    transform: "translate(0 247.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-10",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-19",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-73",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.198)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-73",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.198)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-73",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.198)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-19",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-74",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.262)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-74",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.262)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-74",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.262)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-19",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-75",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.262)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-75",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.262)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-75",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.262)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-19",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-76",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.198)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-76",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.198)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-76",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.198)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-10",
    "data-name": "Group 12442",
    transform: "translate(0 123.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-20",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-77",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.326)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-77",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.326)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-77",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.326)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-20",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-78",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.39)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-78",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.39)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-78",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.39)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-20",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-79",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.134)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-79",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.134)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-79",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.134)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-20",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-80",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.07)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-80",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.07)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-80",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.07)",
    fill: "url(#radial-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12446-3",
    "data-name": "Group 12446",
    transform: "translate(0 495.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-6",
    "data-name": "Group 12443",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-11",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-21",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-81",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.455)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-81",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.455)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-81",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.455)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-21",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-82",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.481)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-82",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.481)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-82",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.481)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-21",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-83",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.006)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-83",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.006)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-83",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.006)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-21",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-84",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.06)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-84",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.06)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-84",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.06)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-11",
    "data-name": "Group 12442",
    transform: "translate(0 123.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-22",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-85",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.416)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-85",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.416)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-85",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.416)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-22",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-86",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.352)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-86",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.352)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-86",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.352)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-22",
    "data-name": "Group 12438",
    transform: "translate(0 30.461)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-87",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.124)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-87",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.124)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-87",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.124)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-22",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-88",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.188)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-88",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.188)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-88",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.188)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-6",
    "data-name": "Group 12444",
    transform: "translate(0 247.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-12",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-23",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-89",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.287)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-89",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.287)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-89",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.287)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-23",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-90",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.223)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-90",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.223)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-90",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.223)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-23",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-91",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.253)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-91",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.253)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-91",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.253)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-23",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-92",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.317)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-92",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.317)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-92",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.317)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-12",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-24",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-93",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.158)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-93",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.158)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-93",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.158)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-24",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-94",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.093)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-94",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.093)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-94",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.093)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-24",
    "data-name": "Group 12438",
    transform: "translate(0 30.461)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-95",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.382)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-95",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.382)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-95",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.382)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-24",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-96",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.447)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-96",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.447)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-96",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.447)",
    fill: "url(#radial-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12448-2",
    "data-name": "Group 12448",
    transform: "translate(0 990.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445-4",
    "data-name": "Group 12445",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-7",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-13",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-25",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-97",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 -0.029)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-97",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 -0.029)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-97",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 -0.029)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-25",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-98",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.036)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-98",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.036)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-98",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.036)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-25",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-99",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.488)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-99",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.488)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-99",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.488)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-25",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-100",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.424)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-100",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.424)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-100",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.424)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-13",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-26",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-101",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.1)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-101",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.1)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-101",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.1)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-26",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-102",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.165)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-102",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.165)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-102",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.165)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-26",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-103",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.36)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-103",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.36)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-103",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.36)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-26",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-104",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.295)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-104",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.295)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-104",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.295)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-7",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-14",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-27",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-105",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.229)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-105",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.229)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-105",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.229)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-27",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-106",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.294)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-106",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.294)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-106",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.294)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-27",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-107",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.231)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-107",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.231)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-107",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.231)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-27",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-108",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.166)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-108",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.166)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-108",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.166)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-14",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-28",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-109",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.358)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-109",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.358)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-109",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.358)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-28",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-110",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.423)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-110",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.423)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-110",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.423)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-28",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-111",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.102)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-111",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.102)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-111",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.102)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-28",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-112",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.037)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-112",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.037)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-112",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.037)",
    fill: "url(#radial-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12446-4",
    "data-name": "Group 12446",
    transform: "translate(0 495.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-8",
    "data-name": "Group 12443",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-15",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-29",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-113",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.487)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-113",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.487)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-113",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.487)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-29",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-114",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.448)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-114",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.448)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-114",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.448)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-29",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-115",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.027)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-115",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.027)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-115",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.027)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-29",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-116",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.092)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-116",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.092)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-116",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.092)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-15",
    "data-name": "Group 12442",
    transform: "translate(0 123.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-30",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-117",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.383)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-117",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.383)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-117",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.383)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-30",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-118",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.318)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-118",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.318)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-118",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.318)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-30",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-119",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.156)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-119",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.156)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-119",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.156)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-30",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-120",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.221)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-120",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.221)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-120",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.221)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-8",
    "data-name": "Group 12444",
    transform: "translate(0 247.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-16",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-31",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-121",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.254)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-121",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.254)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-121",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.254)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-31",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-122",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.19)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-122",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.19)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-122",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.19)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-31",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-123",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.285)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-123",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.285)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-123",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.285)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-31",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-124",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.349)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-124",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.349)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-124",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.349)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-16",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-32",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-125",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.125)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-125",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.125)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-125",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.125)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-32",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-126",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.062)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-126",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.062)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-126",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.062)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-32",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-127",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.414)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-127",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.414)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-127",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.414)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-32",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-128",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.478)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-128",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.478)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-128",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.478)",
    fill: "url(#radial-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12455",
    "data-name": "Group 12455",
    transform: "translate(1769.73 3036.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12447-3",
    "data-name": "Group 12447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445-5",
    "data-name": "Group 12445",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-9",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-17",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-33",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-129",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.125)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-129",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.125)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-129",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.125)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-33",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-130",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.061)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-130",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.061)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-130",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.061)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-33",
    "data-name": "Group 12438",
    transform: "translate(0 31.476)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-131",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.399)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-131",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.399)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-131",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.399)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-33",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-132",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.463)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-132",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.463)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-132",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.463)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-17",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-34",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-133",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.003)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-133",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.003)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-133",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.003)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-34",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-134",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.068)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-134",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.068)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-134",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.068)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-34",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-135",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.472)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-135",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.472)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-135",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.472)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-34",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-136",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.407)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-136",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.407)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-136",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.407)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-9",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-18",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-35",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-137",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.132)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-137",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.132)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-137",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.132)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-35",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-138",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.197)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-138",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.197)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-138",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.197)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-35",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-139",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.343)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-139",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.343)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-139",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.343)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-35",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-140",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.278)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-140",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.278)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-140",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.278)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-18",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-36",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-141",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.262)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-141",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.262)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-141",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.262)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-36",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-142",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.326)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-142",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.326)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-142",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.326)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-36",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-143",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.214)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-143",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.214)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-143",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.214)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-36",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-144",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.149)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-144",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.149)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-144",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.149)",
    fill: "url(#radial-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12446-5",
    "data-name": "Group 12446",
    transform: "translate(0 495.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-10",
    "data-name": "Group 12443",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-19",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-37",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-145",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.39)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-145",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.39)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-145",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.39)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-37",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-146",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.455)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-146",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.455)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-146",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.455)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-37",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-147",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.085)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-147",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.085)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-147",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.085)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-37",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-148",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 -0.02)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-148",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 -0.02)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-148",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 -0.02)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-19",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-38",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-149",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.48)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-149",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.48)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-149",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.48)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-38",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-150",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.416)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-150",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.416)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-150",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.416)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-38",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-151",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.045)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-151",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.045)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-151",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.045)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-38",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-152",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.109)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-152",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.109)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-152",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.109)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-10",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-20",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-39",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-153",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.351)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-153",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.351)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-153",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.351)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-39",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-154",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.287)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-154",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.287)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-154",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.287)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-39",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-155",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.173)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-155",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.173)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-155",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.173)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-39",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-156",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.238)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-156",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.238)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-156",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.238)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-20",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-40",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-157",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.223)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-157",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.223)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-157",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.223)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-40",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-158",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.158)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-158",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.158)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-158",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.158)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-40",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-159",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.302)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-159",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.302)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-159",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.302)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-40",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-160",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.367)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-160",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.367)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-160",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.367)",
    fill: "url(#radial-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12448-3",
    "data-name": "Group 12448",
    transform: "translate(0 990.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445-6",
    "data-name": "Group 12445",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-11",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-21",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-41",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-161",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.093)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-161",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.093)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-161",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.093)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-41",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-162",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.029)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-162",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.029)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-162",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.029)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-41",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-163",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.431)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-163",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.431)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-163",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.431)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-41",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-164",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.496)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-164",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.496)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-164",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.496)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-21",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-42",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-165",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.036)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-165",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.036)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-165",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.036)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-42",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-166",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.1)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-166",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.1)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-166",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.1)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-42",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-167",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.44)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-167",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.44)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-167",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.44)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-42",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-168",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.375)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-168",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.375)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-168",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.375)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-11",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-22",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-43",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-169",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.165)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-169",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.165)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-169",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.165)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-43",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-170",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.229)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-170",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.229)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-170",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.229)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-43",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-171",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.311)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-171",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.311)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-171",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.311)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-43",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-172",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.246)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-172",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.246)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-172",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.246)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-22",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-44",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-173",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.293)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-173",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.293)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-173",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.293)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-44",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-174",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.358)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-174",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.358)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-174",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.358)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-44",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-175",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.181)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-175",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.181)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-175",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.181)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-44",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-176",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.117)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-176",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.117)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-176",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.117)",
    fill: "url(#radial-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12446-6",
    "data-name": "Group 12446",
    transform: "translate(0 495.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-12",
    "data-name": "Group 12443",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-23",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-45",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-177",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.423)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-177",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.423)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-177",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.423)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-45",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-178",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.487)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-178",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.487)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-178",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.487)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-45",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-179",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.052)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-179",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.052)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-179",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.052)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-45",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-180",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.013)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-180",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.013)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-180",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.013)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-23",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-46",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-181",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.448)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-181",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.448)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-181",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.448)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-46",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-182",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.383)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-182",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.383)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-182",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.383)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-46",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-183",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.077)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-183",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.077)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-183",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.077)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-46",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-184",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.141)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-184",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.141)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-184",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.141)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-12",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-24",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-47",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-185",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.319)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-185",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.319)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-185",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.319)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-47",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-186",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.255)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-186",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.255)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-186",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.255)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-47",
    "data-name": "Group 12438",
    transform: "translate(0 31.476)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-187",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.205)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-187",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.205)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-187",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.205)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-47",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-188",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.27)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-188",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.27)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-188",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.27)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-24",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-48",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-189",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.19)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-189",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.19)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-189",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.19)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-48",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-190",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.126)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-190",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.126)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-190",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.126)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-48",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-191",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.334)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-191",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.334)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-191",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.334)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-48",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-192",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.399)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-192",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.399)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-192",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.399)",
    fill: "url(#radial-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12456",
    "data-name": "Group 12456",
    transform: "translate(1769.73 6999.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12447-4",
    "data-name": "Group 12447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445-7",
    "data-name": "Group 12445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-13",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-25",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-49",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-193",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.003)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-193",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.003)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-193",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.003)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-49",
    "data-name": "Group 12440",
    transform: "translate(0 60.92)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-194",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.083)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-194",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.083)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-194",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.083)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-49",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-195",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.457)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-195",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.457)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-195",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.457)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-49",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-196",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.393)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-196",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.393)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-196",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.393)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-25",
    "data-name": "Group 12442",
    transform: "translate(0 122.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-50",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-197",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.147)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-197",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.147)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-197",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.147)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-50",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-198",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.212)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-198",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.212)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-198",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.212)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-50",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-199",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.328)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-199",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.328)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-199",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.328)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-50",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-200",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.264)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-200",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.264)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-200",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.264)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-13",
    "data-name": "Group 12444",
    transform: "translate(0 246.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-26",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-51",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-201",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.277)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-201",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.277)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-201",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.277)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-51",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-202",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.342)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-202",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.342)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-202",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.342)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-51",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-203",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.198)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-203",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.198)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-203",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.198)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-51",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-204",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.134)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-204",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.134)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-204",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.134)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-26",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-52",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-205",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.406)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-205",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.406)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-205",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.406)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-52",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-206",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.471)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-206",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.471)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-206",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.471)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-52",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-207",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.069)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-207",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.069)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-207",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.069)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-52",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-208",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 -0.005)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-208",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 -0.005)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-208",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 -0.005)",
    fill: "url(#radial-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12446-7",
    "data-name": "Group 12446",
    transform: "translate(0 494.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-14",
    "data-name": "Group 12443",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-27",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-53",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-209",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.465)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-209",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.465)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-209",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.465)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-53",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-210",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.401)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-210",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.401)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-210",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.401)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-53",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-211",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.059)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-211",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.059)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-211",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.059)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-53",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-212",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.124)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-212",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.124)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-212",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.124)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-27",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-54",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-213",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.336)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-213",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.336)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-213",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.336)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-54",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-214",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.272)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-214",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.272)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-214",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.272)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-54",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-215",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.188)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-215",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.188)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-215",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.188)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-54",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-216",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.253)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-216",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.253)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-216",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.253)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-14",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-28",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-55",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-217",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.207)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-217",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.207)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-217",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.207)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-55",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-218",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.143)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-218",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.143)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-218",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.143)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-55",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-219",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.317)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-219",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.317)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-219",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.317)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-55",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-220",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.382)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-220",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.382)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-220",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.382)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-28",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-56",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-221",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.078)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-221",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.078)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-221",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.078)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-56",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-222",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.013)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-222",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.013)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-222",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.013)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-56",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-223",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.446)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-223",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.446)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-223",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.446)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-56",
    "data-name": "Group 12439",
    transform: "translate(0 93.41)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-224",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.488)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-224",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.488)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-224",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.488)",
    fill: "url(#radial-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12448-4",
    "data-name": "Group 12448",
    transform: "translate(0 989.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445-8",
    "data-name": "Group 12445",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-15",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-29",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-57",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-225",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.052)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-225",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.052)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-225",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.052)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-57",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-226",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.116)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-226",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.116)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-226",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.116)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-57",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-227",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.424)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-227",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.424)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-227",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.424)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-57",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-228",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.36)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-228",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.36)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-228",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.36)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-29",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-58",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-229",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.181)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-229",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.181)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-229",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.181)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-58",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-230",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.245)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-230",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.245)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-230",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.245)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-58",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-231",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.295)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-231",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.295)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-231",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.295)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-58",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-232",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.231)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-232",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.231)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-232",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.231)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-15",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-30",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-59",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-233",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.309)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-233",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.309)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-233",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.309)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-59",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-234",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.373)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-234",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.373)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-234",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.373)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-59",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-235",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.166)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-235",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.166)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-235",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.166)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-59",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-236",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.102)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-236",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.102)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-236",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.102)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-30",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-60",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-237",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.437)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-237",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.437)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-237",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.437)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-60",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-238",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.498)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-238",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.498)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-238",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.498)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-60",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-239",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 -0.037)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-239",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 -0.037)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-239",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 -0.037)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-60",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-240",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.026)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-240",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.026)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-240",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.026)",
    fill: "url(#radial-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12446-8",
    "data-name": "Group 12446",
    transform: "translate(0 495.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-16",
    "data-name": "Group 12443",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-31",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-61",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-241",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.434)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-241",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.434)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-241",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.434)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-61",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-242",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.369)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-242",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.369)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-242",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.369)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-61",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-243",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.092)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-243",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.092)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-243",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.092)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-61",
    "data-name": "Group 12439",
    transform: "translate(0 93.41)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-244",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.157)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-244",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.157)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-244",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.157)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-31",
    "data-name": "Group 12442",
    transform: "translate(0 123.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-62",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-245",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.304)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-245",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.304)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-245",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.304)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-62",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-246",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.239)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-246",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.239)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-246",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.239)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-62",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-247",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.221)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-247",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.221)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-247",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.221)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-62",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-248",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.285)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-248",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.285)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-248",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.285)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-16",
    "data-name": "Group 12444",
    transform: "translate(0 247.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-32",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-63",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-249",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.175)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-249",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.175)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-249",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.175)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-63",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-250",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.11)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-250",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.11)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-250",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.11)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-63",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-251",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.349)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-251",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.349)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-251",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.349)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-63",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-252",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.414)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-252",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.414)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-252",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.414)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-32",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-64",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-253",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.046)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-253",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.046)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-253",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.046)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-64",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-254",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.018)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-254",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.018)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-254",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.018)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-64",
    "data-name": "Group 12438",
    transform: "translate(0 31.475)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-255",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.478)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-255",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.478)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-255",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.478)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-64",
    "data-name": "Group 12439",
    transform: "translate(0 93.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-256",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.457)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-256",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.457)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-256",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.457)",
    fill: "url(#radial-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12458",
    "data-name": "Group 12458",
    transform: "translate(1769.73 8980.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12447-5",
    "data-name": "Group 12447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445-9",
    "data-name": "Group 12445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-17",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-33",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-65",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-257",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.083)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-257",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.083)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-257",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.083)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-65",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-258",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.147)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-258",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.147)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-258",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.147)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-65",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-259",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.377)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-259",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.377)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-259",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.377)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-65",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-260",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.313)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-260",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.313)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-260",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.313)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-33",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-66",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-261",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.212)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-261",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.212)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-261",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.212)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-66",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-262",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.276)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-262",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.276)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-262",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.276)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-66",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-263",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.248)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-263",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.248)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-263",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.248)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-66",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-264",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.184)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-264",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.184)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-264",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.184)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-17",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-34",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-67",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-265",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.341)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-265",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.341)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-265",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.341)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-67",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-266",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.405)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-266",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.405)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-266",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.405)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-67",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-267",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.119)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-267",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.119)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-267",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.119)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-67",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-268",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.055)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-268",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.055)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-268",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.055)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-34",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-68",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-269",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.47)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-269",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.47)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-269",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.47)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-68",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-270",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.465)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-270",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.465)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-270",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.465)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-68",
    "data-name": "Group 12438",
    transform: "translate(0 30.459)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-271",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.011)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-271",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.011)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-271",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.011)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-68",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-272",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.075)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-272",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.075)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-272",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.075)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12459",
    "data-name": "Group 12459",
    transform: "translate(0 247.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-69",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-273",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.401)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-273",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.401)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-273",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.401)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-69",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-274",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.336)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-274",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.336)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-274",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.336)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-69",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-275",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.14)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-275",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.14)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-275",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.14)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-69",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-276",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.204)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-276",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.204)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-276",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.204)",
    fill: "url(#radial-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12703",
    "data-name": "Group 12703",
    transform: "translate(1769.73 9599.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12447-6",
    "data-name": "Group 12447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12445-10",
    "data-name": "Group 12445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12443-18",
    "data-name": "Group 12443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-35",
    "data-name": "Group 12441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-70",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-277",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.083)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-277",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.083)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-277",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.083)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-70",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-278",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.147)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-278",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.147)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-278",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.147)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-70",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-279",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.377)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-279",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.377)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-279",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.377)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-70",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-280",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.313)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-280",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.313)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-280",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.313)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-35",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-71",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-281",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.212)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-281",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.212)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-281",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.212)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-71",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-282",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.276)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-282",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.276)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-282",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.276)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-71",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-283",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.248)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-283",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.248)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-283",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.248)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-71",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-284",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.184)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-284",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.184)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-284",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.184)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12444-18",
    "data-name": "Group 12444",
    transform: "translate(0 247.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12441-36",
    "data-name": "Group 12441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-72",
    "data-name": "Group 12437"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-285",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.341)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-285",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.341)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-285",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.341)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-72",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-286",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.405)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-286",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.405)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-286",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.405)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-72",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-287",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.119)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-287",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.119)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-287",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.119)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-72",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-288",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.27 -0.055)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-288",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(32.27 -0.055)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-288",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 16,
    rx: 15,
    ry: 16,
    transform: "translate(64.27 -0.055)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12442-36",
    "data-name": "Group 12442",
    transform: "translate(0 123.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-73",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_615-289",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(0.27 0.47)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616-289",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(32.27 0.47)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_617-289",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(64.27 0.47)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-73",
    "data-name": "Group 12440",
    transform: "translate(0 61.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-290",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.465)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-290",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.465)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-290",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.465)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-73",
    "data-name": "Group 12438",
    transform: "translate(0 30.459)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-291",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.011)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-291",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.011)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-291",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.011)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-73",
    "data-name": "Group 12439",
    transform: "translate(0 92.395)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-292",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.075)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-292",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.075)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-292",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.075)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12459-2",
    "data-name": "Group 12459",
    transform: "translate(0 247.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437-74",
    "data-name": "Group 12437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-293",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.401)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-293",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.401)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-293",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.401)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12440-74",
    "data-name": "Group 12440",
    transform: "translate(0 61.936)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-294",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 -0.336)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-294",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 -0.336)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-294",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 -0.336)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12438-74",
    "data-name": "Group 12438",
    transform: "translate(0 30.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-295",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.14)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-295",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.14)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-295",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.14)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12439-74",
    "data-name": "Group 12439",
    transform: "translate(0 92.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_615-296",
    "data-name": "Ellipse 615",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.27 0.204)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_616-296",
    "data-name": "Ellipse 616",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.27 0.204)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617-296",
    "data-name": "Ellipse 617",
    cx: 15,
    cy: 15.5,
    rx: 15,
    ry: 15.5,
    transform: "translate(64.27 0.204)",
    fill: "url(#radial-gradient)"
  }))))))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_618",
    "data-name": "Ellipse 618",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(1786 1028)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_619",
    "data-name": "Ellipse 619",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(1817 1028)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_627",
    "data-name": "Ellipse 627",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(1802 999)",
    fill: "url(#radial-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftdesign);
export default __webpack_public_path__ + "static/media/leftdesign.9ccab9c196fcf16a1b8948ee19013f77.svg";
export { ForwardRef as ReactComponent };